import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/ui.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ensureApiConfig } from './api/client';

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  ensureApiConfig();
  root.render(
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>,
  );
} catch (err) {
  root.render(
    <div
      style={{
        padding: 24,
        fontFamily: 'system-ui, sans-serif',
        maxWidth: 480,
        margin: '40px auto',
        background: '#fff8e1',
        border: '1px solid #ffc107',
        borderRadius: 8,
      }}
      role="alert"
    >
      <strong>Configuration required</strong>
      <p style={{ margin: '12px 0 0' }}>{err.message}</p>
    </div>,
  );
}

